import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IEmailTemplateActionTypes } from "../../action-types/email/IEmailTemplateActionTypes";
import { IEmailTemplateReducer } from "../../page-state-model/email/IEmailTemplateReducer";
const iniState: IEmailTemplateReducer = {
    emailTemplates: [],
    status: ePageBaseStatus.is_not_initialization,
    emailTemplateEditing: undefined,
    isShowEditModal: false
}
export const emailTemplateReducer = (state: IEmailTemplateReducer = iniState, action: IEmailTemplateActionTypes): IEmailTemplateReducer => {
    switch (action.type) {
        case "EMAIL_TEMPLATE_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "EMAIL_TEMPLATE_LOAD_SUCCCES":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                emailTemplates: action.payload
            }
        case "EMAIL_TEMPLATE_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                emailTemplates: []
            }
        case "EMAIL_TEMPLATE_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                emailTemplateEditing: action.payload
            }
        case "EMAIL_TEMPLATE_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "EMAIL_TEMPLATE_SAVE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_saving
            }
        case "EMAIL_TEMPLATE_SAVE_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                emailTemplates: [...state.emailTemplates.filter(x => x.id !== action.payload.id), action.payload]
            }
        case "EMAIL_TEMPLATE_SAVE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed
            }
        case "EMAIL_TEMPLATE_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting
            }
        case "EMAIL_TEMPLATE_DELETE_SUCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }
        case "EMAIL_TEMPLATE_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        default:
            return state;
    }
}